import React from 'react';
import { Modal } from 'carbon-components-react';
import CustomButton from '../../custom-button/custom-btn.component';
import { Printer } from 'react-feather';
import { formatCurrency, formatDate } from '../../../utils/common.util';

import './transaction-report.styles.scss';
import { PrintView } from '../../PrintView/print-view.component';

const TransactionReportPrintOutModal = ({
  openModal,
  data,
  filterTexts,
  school,
  closeAction,
}) => {
  return (
    <Modal
      id="transaction-report-modal"
      className="transaction-report-modal"
      hasScrollingContent
      passiveModal={true}
      open={openModal}
      primaryButtonDisabled={false}>
      <PrintView>
        <div style={{ pageBreakAfter: 'always' }}>
          <div className="mt-15 bx--col--auto mb-10">
            <div
              className="school-logo center"
              style={{ backgroundImage: `url(${school.logoUrl})` }}></div>
            <h3 className="h-24 text-primary text-center">{school.name}</h3>
            <p className="text-14 text-grey-dark text-center">
              {school.location}
            </p>

            <p className="text-center text-16 text-primary font-bold mt-10 text-uppercase">
              JOURNAL VOUCHER REPORT
            </p>
          </div>

          <div className="info d-flex-space-between mt-10">
            {filterTexts.map((el) => (
              <div>
                <p className="text-14 text-grey-light">{el.label}</p>
                <h3 className="h-14">{el.text}</h3>
              </div>
            ))}
          </div>

          {data && (
            <div className="mt-15">
              <table className="bx--data-table table-white">
                <thead>
                  <tr>
                    <th>Date Created</th>
                    <th>Tranaction Date</th>
                    <th>JE Number</th>
                    <th>Reference Number</th>
                    <th>Memo</th>
                    <th>Debit</th>
                    <th>Credit</th>
                    <td>Status</td>
                  </tr>
                </thead>
                <tbody>
                  {data.flatMap((entry) =>
                    entry.lines.map((line, index) => {
                      return (
                        <tr key={`${entry.id}-${index}`}>
                          <td>{formatDate(entry.createdDateTime)}</td>
                          <td>{formatDate(entry.transactionDate)}</td>
                          <td>{entry.documentNumber}</td>
                          <td>{entry.referenceNumber}</td>
                          <td>{line.memo || entry.memo}</td>
                          <td>{formatCurrency(line.debitAmount)}</td>
                          <td>{formatCurrency(line.creditAmount)}</td>
                          <td>{entry.status}</td>
                        </tr>
                      );
                    }),
                  )}
                </tbody>
              </table>

              <div className="bx--row">
                <div className="bx--col-lg-8"></div>

                <div className="bx--col-lg-2">
                  <CustomButton
                    classes="secondary  f-width font-bold  mt-35"
                    onClick={closeAction}>
                    CLOSE
                  </CustomButton>
                </div>
                <div className="bx--col-lg-2">
                  <CustomButton
                    classes="primary f-width font-bold mt-35"
                    onClick={() => window.print()}>
                    <Printer size="11" strokeWidth="5px" /> &nbsp; PRINT
                  </CustomButton>
                </div>
              </div>
            </div>
          )}
        </div>
      </PrintView>
    </Modal>
  );
};

export default TransactionReportPrintOutModal;
